































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'OtherPixFields',
  props: {
    beneficiaryName: {
      required: true,
      type: String,
      default: '',
    },
    beneficiaryDocument: {
      required: true,
      type: String,
      default: '',
    },
  },
  data() {
    const required = (value: string | number) => !!value || 'Campo obrigatório!';

    const beneficiaryNameModel: string = this.beneficiaryName;
    const beneficiaryDocumentModel: string = this.beneficiaryDocument;

    return {
      required,
      beneficiaryNameModel,
      beneficiaryDocumentModel,
    };
  },
  computed: {
    mask() {
      let mask: string | null = '';

    const documentWithoutFormattation = this.beneficiaryDocumentModel
      ? this.beneficiaryDocumentModel
          .replaceAll(' ', '')
          .replaceAll('.', '')
          .replaceAll('-', '')
          .replaceAll('/', '')
          .replaceAll('(', '')
          .replaceAll(')', '')
      : '';

      if (documentWithoutFormattation.length <= 11) {
        mask = '###.###.###-###';
      } else if (documentWithoutFormattation.length > 11) {
        mask = '##.###.###/####-##';
      }

      return mask;
    },
  },
  methods: {
    handleOnChangeField(): void {
      this.$emit('on-change-fields', {
        name: this.beneficiaryNameModel,
        document: this.beneficiaryDocumentModel,
      });
    },
  },
});
